export const SURF_COMPOSITION_KINDS = [
    "text-left",
    "text-right",
    "text-top",
    "text-bottom",
    "center-panel",
    "split",
    "full-bleed",
];
export const COMPOSITION_CATALOG = {
    "text-left": {
        calmZones: [{ x: 0.52, y: 0.08, w: 0.44, h: 0.84 }],
        subjectRegion: { x: 0.02, y: 0.02, w: 0.46, h: 0.96 },
        scrim: "soft",
    },
    "text-right": {
        calmZones: [{ x: 0.04, y: 0.08, w: 0.44, h: 0.84 }],
        subjectRegion: { x: 0.52, y: 0.02, w: 0.46, h: 0.96 },
        scrim: "soft",
    },
    "text-top": {
        calmZones: [{ x: 0.08, y: 0.52, w: 0.84, h: 0.42 }],
        subjectRegion: { x: 0.02, y: 0.02, w: 0.96, h: 0.46 },
        scrim: "soft",
    },
    "text-bottom": {
        calmZones: [{ x: 0.08, y: 0.08, w: 0.84, h: 0.42 }],
        subjectRegion: { x: 0.02, y: 0.52, w: 0.96, h: 0.46 },
        scrim: "soft",
    },
    "center-panel": {
        calmZones: [{ x: 0.12, y: 0.22, w: 0.76, h: 0.56 }],
        subjectRegion: { x: 0.02, y: 0.02, w: 0.96, h: 0.96 },
        scrim: "strong",
    },
    split: {
        calmZones: [{ x: 0.52, y: 0.08, w: 0.44, h: 0.84 }],
        subjectRegion: { x: 0.04, y: 0.08, w: 0.44, h: 0.84 },
        scrim: "none",
    },
    "full-bleed": {
        calmZones: [],
        subjectRegion: { x: 0, y: 0, w: 1, h: 1 },
        scrim: "none",
    },
};
export function getCompositionSpec(kind) {
    if (kind && COMPOSITION_CATALOG[kind])
        return COMPOSITION_CATALOG[kind];
    return COMPOSITION_CATALOG["text-left"];
}
export function compositionRegionPromptLines(spec) {
    const { subjectRegion: r, calmZones } = spec;
    const lines = [
        `Place the illustration within normalized region x=${r.x.toFixed(2)} y=${r.y.toFixed(2)} w=${r.w.toFixed(2)} h=${r.h.toFixed(2)} (subjectRegion).`,
    ];
    if (calmZones.length === 0) {
        lines.push("Full-bleed composition: no calm zone reserved; subject may fill the frame.");
        return lines;
    }
    const z = calmZones[0];
    lines.push(`Keep calmZones empty, uncluttered, low-detail at x=${z.x.toFixed(2)} y=${z.y.toFixed(2)} w=${z.w.toFixed(2)} h=${z.h.toFixed(2)}.`);
    return lines;
}
